import { Component } from '@angular/core';

import { useDispatcher } from '../../../store.decorator';

import { reload } from './state/reload.action';
import { TranslationKeyMap } from './task-list-dialog.i18n';
import { TaskListDialogService } from './task-list-dialog.service';

@Component({
    selector: 'cmps-task-list-dialog',
    templateUrl: './task-list-dialog.component.html',
    host: {
        class: 'cmps-task-list-dialog',
    },
})
export class TaskListDialogComponent {
    /** @private */
    _i18n = TranslationKeyMap;

    /** @private */
    readonly _dataContainerValue: string;

    constructor(/** @private */ readonly _service: TaskListDialogService) {
        this._dataContainerValue = Math.random().toString();
    }

    /** @private */
    _onHasValidTokenChange(hasValidToken: boolean): void {
        if (!hasValidToken) {
            console.log('no valid msft token');
            return;
        }
        useDispatcher(this._service, reload({}));
        void this._service.socketService.listTasks();
    }
}
